import Axios from 'axios'
import ui from '@bmp-vue/core/api/ui'
import util from '@bmp-vue/core/api/util'
import notificationHelper from '@/utils/notificationHelper';

const axios = {
  Get: function (controller, id) {
    util.store.commit('addRequest')
    if (id) {
      return Axios.get(
        process.env.VUE_APP_ROOT_API + controller + '/' + id
      ).then(HandleResponseBase, HandleErrorBase)
    } else {
      return Axios.get(
        process.env.VUE_APP_ROOT_API + controller
      ).then(HandleResponseBase, HandleErrorBase)
    }
  },
  GetAll: function (controller, dto) {
    util.store.commit('addRequest')
    return Axios.get(process.env.VUE_APP_ROOT_API + controller, {
      params: {
        request: dto || {}
      }
    }).then(HandleResponseBase, HandleErrorBase)
  },
  GetBlob: function (controller, dto) {
    util.store.commit('addRequest')
    return Axios.get(process.env.VUE_APP_ROOT_API + controller, {
      params: { request: dto || {} },
      responseType: 'blob' // Force to receive data in a Blob Format
    }).then(HandleResponseBase, p => HandleBlobErrorBase(p).then())
  },
  PostBlob: function (controller, dto) {
    util.store.commit('addRequest')
    return Axios.post(process.env.VUE_APP_ROOT_API + controller, dto, { responseType: 'blob' }).then(
      HandleResponseBase, p => HandleBlobErrorBase(p).then())
  },
  Post: function (controller, dto, headers) {
    util.store.commit('addRequest')
    if (headers) {
      return Axios.post(process.env.VUE_APP_ROOT_API + controller, dto, headers).then(
        HandleResponseBase,
        HandleErrorBase
      )
    } else {
      return Axios.post(process.env.VUE_APP_ROOT_API + controller, dto).then(
        HandleResponseBase,
        HandleErrorBase
      )
    }
  },
  PostForm: function (controller, dto) {
    util.store.commit('addRequest')
    return Axios.post(process.env.VUE_APP_ROOT_API + controller, dto, { headers: { 'Content-Type': `multipart/form-data; boundary=${dto._boundary}` } }).then(
      HandleResponseBase,
      HandleErrorBase
    )
  },
  Put: function (controller, id, dto) {
    util.store.commit('addRequest')
    if (!dto) {
      dto = {}
    }
    return Axios.put(
      process.env.VUE_APP_ROOT_API + controller + '/' + id,
      dto
    ).then(HandleResponseBase, HandleErrorBase)
  },
  PutWithoutId: function (controller, dto) {
    util.store.commit('addRequest')
    if (!dto) {
      dto = {}
    }
    return Axios.put(
      process.env.VUE_APP_ROOT_API + controller,
      dto
    ).then(HandleResponseBase, HandleErrorBase)
  },
  Persist: function (controller, dto, key) {
    if (!dto) { dto = {} }

    if (!key) { key = 'codigo' }

    if (dto[key]) { return api.Axios.Put(controller, dto[key], dto) } else { return api.Axios.Post(controller, dto) }
  },
  Delete: function (controller, id) {
    util.store.commit('addRequest')
    return Axios.delete(process.env.VUE_APP_ROOT_API + controller + '/' + (id || ''))
      .then(HandleResponseBase, HandleErrorBase)
  },
  DeleteAll: function (controller, dto) {
    util.store.commit('addRequest')
    return Axios.delete(process.env.VUE_APP_ROOT_API + controller, { params: dto })
      .then(HandleResponseBase, HandleErrorBase)
  },
  Dynamic: function (action, ...args) {
    util.store.commit('addRequest')
    return Axios[action](...args).then(
      HandleResponseBase,
      HandleErrorBase
    )
  },
  GetParams: function (controller, paramns) {
    util.store.commit('addRequest')
    if (!paramns) { paramns = {} }
    return Axios.get(process.env.VUE_APP_ROOT_API + controller, { params: paramns })
      .then(HandleResponseBase, HandleErrorBase)
  }
}

const api = {
  ...util,
  UI: ui,
  UTIL: util,
  Axios: axios,
  GetCrud: function (controller, methods) {
    var factory = {}
    if (!methods || (methods && methods.indexOf('get') >= 0)) {
      factory.Get = function (id, loading, notification) {
        return api.Axios.Get(controller, id, loading, notification)
      }
    }

    if (!methods || (methods && methods.indexOf('getall') >= 0)) {
      factory.GetAll = function (dto, loading, notification) {
        return api.Axios.GetAll(controller, dto, loading, notification)
      }
    }

    if (!methods || (methods && methods.indexOf('post') >= 0)) {
      factory.Post = function (dto, loading, notification) {
        return api.Axios.Post(controller, dto, loading, notification)
      }
    }

    if (!methods || (methods && methods.indexOf('put') >= 0)) {
      factory.Put = function (id, dto, loading, notification) {
        return api.Axios.Put(controller, id, dto, loading, notification)
      }
    }

    if (!methods || (methods && methods.indexOf('persist') >= 0)) {
      factory.Persist = function (dto, key, loading, notification) {
        return api.Axios.Persist(controller, dto, key, loading, notification)
      }
    }

    if (!methods || (methods && methods.indexOf('delete') >= 0)) {
      factory.Delete = function (id, loading, notification) {
        return api.Axios.Delete(controller, id, loading, notification)
      }
    }
    // utilizado na montagem da api index.js
    factory.controller = controller

    return factory
  },
  HandleResponseBase,
  HandleErrorBase
};

function HandleResponseBase(response, loading = true) {
  if (loading) {
    util.store.commit('removeRequest');
  }

  return response.data;
}

const notify = notificationHelper(ui);

function HandleErrorBase(error, loading = true, notification = true) {
  if (loading) {
    util.store.commit('removeRequest');
  }

  const response = error?.response?.data;

  if (!response) {
    if (notification) {
      ui.ShowError('Erro', 'Ocorreu um erro inesperado');
    }
    return { data: { hasError: true }, hasError: true };
  }

  // Processa erros se existirem e notification estiver habilitado
  if (notification) {
    const errors = response.erros || response.Erros || [];
    if (Array.isArray(errors) && errors.length > 0) {
      // Usa o helper para cada erro
      errors.forEach(erro => {
        notify.showError(erro);
      });
    } else if (response.erros || response.Erros) {
      // Caso não seja array, tenta processar diretamente
      notify.showError(response);
    }
  }

  return response;
}

function HandleBlobErrorBase(error) {
  return new Promise((resolve) => {
    util.store.commit('removeRequest')
    if (error && error.response) {
      var fr = new FileReader();

      fr.onload = function () {
        const response = JSON.parse(this.result)
        resolve({
          success: false, codErro: error.response.status, mensagem: error.response.status + ' - ' + response.Message
        })
      }

      fr.readAsText(error.response.data);
    } else { HandleErrorBase(error) }
  })
}

export default api